import { render, staticRenderFns } from "./ReportImageWheel.vue?vue&type=template&id=f51e84a8"
import script from "./ReportImageWheel.vue?vue&type=script&lang=ts"
export * from "./ReportImageWheel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports